import vitalnya1back from "./interiors/vitalnya/1/back.jpg";
import vitalnya1mask1 from "./interiors/vitalnya/1/1.png";
import vitalnya1mask2 from "./interiors/vitalnya/1/2.png";
import vitalnya1mask3 from "./interiors/vitalnya/1/3.png";
import vitalnya1mask4 from "./interiors/vitalnya/1/4.png";

import vitalnya4back from "./interiors/vitalnya/4/back.jpg";
import vitalnya4mask1 from "./interiors/vitalnya/4/1.png";
import vitalnya4mask2 from "./interiors/vitalnya/4/2.png";
import vitalnya4mask3 from "./interiors/vitalnya/4/3.png";
import vitalnya4mask4 from "./interiors/vitalnya/4/4.png";

import vitalnya5back from "./interiors/vitalnya/5/back.jpg";
import vitalnya5mask1 from "./interiors/vitalnya/5/1.png";
import vitalnya5mask2 from "./interiors/vitalnya/5/2.png";
import vitalnya5mask3 from "./interiors/vitalnya/5/3.png";
import vitalnya5mask4 from "./interiors/vitalnya/5/4.png";

import dityacha1back from "./interiors/dityacha/1/back.jpg";
import dityacha1mask1 from "./interiors/dityacha/1/1.png";
import dityacha1mask2 from "./interiors/dityacha/1/2.png";
import dityacha1mask3 from "./interiors/dityacha/1/3.png";
import dityacha1mask4 from "./interiors/dityacha/1/4.png";
import dityacha1mask5 from "./interiors/dityacha/1/5.png";
import dityacha1mask6 from "./interiors/dityacha/1/6.png";
import dityacha1mask7 from "./interiors/dityacha/1/7.png";

import dityacha2back from "./interiors/dityacha/2/back.jpg";
import dityacha2mask1 from "./interiors/dityacha/2/1.png";
import dityacha2mask2 from "./interiors/dityacha/2/2.png";
import dityacha2mask3 from "./interiors/dityacha/2/3.png";

import dityacha3back from "./interiors/dityacha/3/back.jpg";
import dityacha3mask1 from "./interiors/dityacha/3/1.png";
import dityacha3mask2 from "./interiors/dityacha/3/2.png";
import dityacha3mask3 from "./interiors/dityacha/3/3.png";

import kuhnya1back from "./interiors/kuhnya/1/back.jpg";
import kuhnya1mask1 from "./interiors/kuhnya/1/1.png";
import kuhnya1mask2 from "./interiors/kuhnya/1/2.png";
import kuhnya1mask3 from "./interiors/kuhnya/1/3.png";
import kuhnya1mask4 from "./interiors/kuhnya/1/4.png";

import kuhnya2back from "./interiors/kuhnya/2/back.jpg";
import kuhnya2mask1 from "./interiors/kuhnya/2/1.png";
import kuhnya2mask2 from "./interiors/kuhnya/2/2.png";
import kuhnya2mask3 from "./interiors/kuhnya/2/3.png";

import kuhnya3back from "./interiors/kuhnya/3/back.jpg";
import kuhnya3mask1 from "./interiors/kuhnya/3/1.png";
import kuhnya3mask2 from "./interiors/kuhnya/3/2.png";
import kuhnya3mask3 from "./interiors/kuhnya/3/3.png";

import office1back from "./interiors/office/1/back.jpg";
import office1mask1 from "./interiors/office/1/1.png";
import office1mask2 from "./interiors/office/1/2.png";
import office1mask3 from "./interiors/office/1/3.png";

import office2back from "./interiors/office/2/back.jpg";
import office2mask1 from "./interiors/office/2/1.png";
import office2mask2 from "./interiors/office/2/2.png";
import office2mask3 from "./interiors/office/2/3.png";
import office2mask4 from "./interiors/office/2/4.png";

import office3back from "./interiors/office/3/back.jpg";
import office3mask1 from "./interiors/office/3/1.png";
import office3mask2 from "./interiors/office/3/2.png";
import office3mask3 from "./interiors/office/3/3.png";
import office3mask4 from "./interiors/office/3/4.png";

import peredpokiy1back from "./interiors/peredpokiy/1/back.jpg";
import peredpokiy1mask1 from "./interiors/peredpokiy/1/1.png";
import peredpokiy1mask2 from "./interiors/peredpokiy/1/2.png";
import peredpokiy1mask3 from "./interiors/peredpokiy/1/3.png";
import peredpokiy1mask4 from "./interiors/peredpokiy/1/4.png";

import peredpokiy2back from "./interiors/peredpokiy/2/back.jpg";
import peredpokiy2mask1 from "./interiors/peredpokiy/2/1.png";
import peredpokiy2mask2 from "./interiors/peredpokiy/2/2.png";
import peredpokiy2mask3 from "./interiors/peredpokiy/2/3.png";

import peredpokiy3back from "./interiors/peredpokiy/3/back.jpg";
import peredpokiy3mask1 from "./interiors/peredpokiy/3/1.png";
import peredpokiy3mask2 from "./interiors/peredpokiy/3/2.png";
import peredpokiy3mask3 from "./interiors/peredpokiy/3/3.png";
import peredpokiy3mask4 from "./interiors/peredpokiy/3/4.png";

import wc1back from "./interiors/wc/1/back.jpg";
import wc1mask1 from "./interiors/wc/1/1.png";
import wc1mask2 from "./interiors/wc/1/2.png";
import wc1mask3 from "./interiors/wc/1/3.png";
import wc1mask4 from "./interiors/wc/1/4.png";

import wc2back from "./interiors/wc/2/back.jpg";
import wc2mask1 from "./interiors/wc/2/1.png";
import wc2mask2 from "./interiors/wc/2/2.png";
import wc2mask3 from "./interiors/wc/2/3.png";
import wc2mask4 from "./interiors/wc/2/4.png";
import wc2mask5 from "./interiors/wc/2/5.png";

import wc3back from "./interiors/wc/3/back.jpg";
import wc3mask1 from "./interiors/wc/3/1.png";
import wc3mask2 from "./interiors/wc/3/2.png";
import wc3mask3 from "./interiors/wc/3/3.png";

import bedroom1back from "./interiors/bedroom/1/back.jpg";
import bedroom1mask1 from "./interiors/bedroom/1/1.png";
import bedroom1mask2 from "./interiors/bedroom/1/2.png";
import bedroom1mask3 from "./interiors/bedroom/1/3.png";
import bedroom1mask4 from "./interiors/bedroom/1/4.png";

import bedroom2back from "./interiors/bedroom/2/back.jpg";
import bedroom2mask1 from "./interiors/bedroom/2/1.png";
import bedroom2mask2 from "./interiors/bedroom/2/2.png";
import bedroom2mask3 from "./interiors/bedroom/2/3.png";

import bedroom3back from "./interiors/bedroom/3/back.jpg";
import bedroom3mask1 from "./interiors/bedroom/3/1.png";
import bedroom3mask2 from "./interiors/bedroom/3/2.png";
import bedroom3mask3 from "./interiors/bedroom/3/3.png";

import cottage1back from "./exteriors/cottage/1/back.jpg";
import cottage1mask1 from "./exteriors/cottage/1/1.png";
import cottage1mask2 from "./exteriors/cottage/1/2.png";
import cottage1mask3 from "./exteriors/cottage/1/3.png";

import cottage2back from "./exteriors/cottage/2/back.jpg";
import cottage2mask1 from "./exteriors/cottage/2/1.png";
import cottage2mask2 from "./exteriors/cottage/2/2.png";
import cottage2mask3 from "./exteriors/cottage/2/3.png";

import cottage3back from "./exteriors/cottage/3/back.jpg";
import cottage3mask1 from "./exteriors/cottage/3/1.png";
import cottage3mask2 from "./exteriors/cottage/3/2.png";
import cottage3mask3 from "./exteriors/cottage/3/3.png";

import townhouse1back from "./exteriors/townhouse/1/back.jpg";
import townhouse1mask1 from "./exteriors/townhouse/1/1.png";
import townhouse1mask2 from "./exteriors/townhouse/1/2.png";
import townhouse1mask3 from "./exteriors/townhouse/1/3.png";

import townhouse2back from "./exteriors/townhouse/2/back.jpg";
import townhouse2mask1 from "./exteriors/townhouse/2/1.png";
import townhouse2mask2 from "./exteriors/townhouse/2/2.png";
import townhouse2mask3 from "./exteriors/townhouse/2/3.png";

import townhouse3back from "./exteriors/townhouse/3/back.jpg";
import townhouse3mask1 from "./exteriors/townhouse/3/1.png";
import townhouse3mask2 from "./exteriors/townhouse/3/2.png";
import townhouse3mask3 from "./exteriors/townhouse/3/3.png";

import highrise1back from "./exteriors/highrise/1/back.jpg";
import highrise1mask1 from "./exteriors/highrise/1/1.png";
import highrise1mask2 from "./exteriors/highrise/1/2.png";
import highrise1mask3 from "./exteriors/highrise/1/3.png";

import highrise2back from "./exteriors/highrise/2/back.jpg";
import highrise2mask1 from "./exteriors/highrise/2/1.png";
import highrise2mask2 from "./exteriors/highrise/2/2.png";
import highrise2mask3 from "./exteriors/highrise/2/3.png";

import highrise3back from "./exteriors/highrise/3/back.jpg";
import highrise3mask1 from "./exteriors/highrise/3/1.png";
import highrise3mask2 from "./exteriors/highrise/3/2.png";
import highrise3mask3 from "./exteriors/highrise/3/3.png";

import administrative1back from "./exteriors/administrative/1/back.jpg";
import administrative1mask1 from "./exteriors/administrative/1/1.png";
import administrative1mask2 from "./exteriors/administrative/1/2.png";
import administrative1mask3 from "./exteriors/administrative/1/3.png";

import administrative2back from "./exteriors/administrative/2/back.jpg";
import administrative2mask1 from "./exteriors/administrative/2/1.png";
import administrative2mask2 from "./exteriors/administrative/2/2.png";
import administrative2mask3 from "./exteriors/administrative/2/3.png";

import administrative3back from "./exteriors/administrative/3/back.jpg";
import administrative3mask1 from "./exteriors/administrative/3/1.png";
import administrative3mask2 from "./exteriors/administrative/3/2.png";
import administrative3mask3 from "./exteriors/administrative/3/3.png";
import administrative3mask4 from "./exteriors/administrative/3/4.png";

export const fakeApi = [
  {
    id: 1,
    type: "interior",
    data: [
      {
        id: 1,
        tag: "Вітальня",
        link: "vitalnya",
        rooms: [
          {
            id: 1,
            background: vitalnya1back,
            masks: [
              {
                id: 1,
                img: vitalnya1mask3,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 410,
                  y: 65,
                },
              },
              {
                id: 2,
                img: vitalnya1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 150,
                  y: 140,
                },
              },
              {
                id: 3,
                img: vitalnya1mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 400,
                  y: 150,
                },
              },
              {
                id: 4,
                img: vitalnya1mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 700,
                  y: 150,
                },
              },
            ],
          },
          {
            id: 4,
            background: vitalnya4back,
            masks: [
              {
                id: 1,
                img: vitalnya4mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 520,
                  y: 40,
                },
              },
              {
                id: 2,
                img: vitalnya4mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 150,
                  y: 180,
                },
              },
              {
                id: 3,
                img: vitalnya4mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 770,
                  y: 70,
                },
              },
              {
                id: 4,
                img: vitalnya4mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "D",
                },
                position: {
                  x: 870,
                  y: 100,
                },
              },
            ],
          },
          {
            id: 5,
            background: vitalnya5back,
            masks: [
              {
                id: 1,
                img: vitalnya5mask2,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 550,
                  y: 30,
                },
              },
              {
                id: 2,
                img: vitalnya5mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 100,
                  y: 130,
                },
              },
              {
                id: 3,
                img: vitalnya5mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 555,
                  y: 130,
                },
              },
              {
                id: 4,
                img: vitalnya5mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 770,
                  y: 100,
                },
              },
            ],
          },
        ],
      },
      {
        id: 2,
        tag: "Дитяча",
        link: "dityacha",
        rooms: [
          {
            id: 1,
            background: dityacha1back,
            masks: [
              {
                id: 1,
                img: dityacha1mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 450,
                  y: 25,
                },
              },
              {
                id: 2,
                img: dityacha1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 236,
                  y: 270,
                },
              },
              {
                id: 3,
                img: dityacha1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 480,
                  y: 240,
                },
              },
              {
                id: 4,
                img: dityacha1mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 451,
                  y: 130,
                },
              },
              {
                id: 5,
                img: dityacha1mask5,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "D",
                },
                position: {
                  x: 745,
                  y: 235,
                },
              },
              {
                id: 6,
                img: dityacha1mask6,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "E",
                },
                position: {
                  x: 745,
                  y: 130,
                },
              },
              {
                id: 7,
                img: dityacha1mask7,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "F",
                },
                position: {
                  x: 250,
                  y: 130,
                },
              },
            ],
          },
          {
            id: 2,
            background: dityacha2back,
            masks: [
              {
                id: 1,
                img: dityacha2mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 530,
                  y: 40,
                },
              },
              {
                id: 2,
                img: dityacha2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 100,
                  y: 110,
                },
              },
              {
                id: 3,
                img: dityacha2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 785,
                  y: 130,
                },
              },
            ],
          },
          {
            id: 3,
            background: dityacha3back,
            masks: [
              {
                id: 1,
                img: dityacha3mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 578,
                  y: 90,
                },
              },
              {
                id: 2,
                img: dityacha3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 115,
                  y: 198,
                },
              },
              {
                id: 3,
                img: dityacha3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 315,
                  y: 100,
                },
              },
            ],
          },
        ],
      },
      {
        id: 3,
        tag: "Кухня",
        link: "kuhnya",
        rooms: [
          {
            id: 1,
            background: kuhnya1back,
            masks: [
              {
                id: 1,
                img: kuhnya1mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 290,
                  y: 40,
                },
              },
              {
                id: 2,
                img: kuhnya1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 50,
                  y: 130,
                },
              },
              {
                id: 3,
                img: kuhnya1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 550,
                  y: 70,
                },
              },
              {
                id: 4,
                img: kuhnya1mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 850,
                  y: 130,
                },
              },
            ],
          },
          {
            id: 2,
            background: kuhnya2back,
            masks: [
              {
                id: 1,
                img: kuhnya2mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 525,
                  y: 25,
                },
              },
              {
                id: 2,
                img: kuhnya2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 670,
                  y: 100,
                },
              },
              {
                id: 3,
                img: kuhnya2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 315,
                  y: 60,
                },
              },
            ],
          },
          {
            id: 3,
            background: kuhnya3back,
            masks: [
              {
                id: 1,
                img: kuhnya3mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 460,
                  y: 40,
                },
              },
              {
                id: 2,
                img: kuhnya3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 368,
                  y: 177,
                },
              },
              {
                id: 3,
                img: kuhnya3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 750,
                  y: 130,
                },
              },
            ],
          },
        ],
      },
      {
        id: 4,
        tag: "Офіс",
        link: "office",
        rooms: [
          {
            id: 1,
            background: office1back,
            masks: [
              {
                id: 1,
                img: office1mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 204,
                  y: 30,
                },
              },
              {
                id: 2,
                img: office1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 215,
                  y: 170,
                },
              },
              {
                id: 3,
                img: office1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 715,
                  y: 160,
                },
              },
            ],
          },
          {
            id: 2,
            background: office2back,
            masks: [
              {
                id: 1,
                img: office2mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 470,
                  y: 25,
                },
              },
              {
                id: 2,
                img: office2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 365,
                  y: 150,
                },
              },
              {
                id: 3,
                img: office2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 603,
                  y: 130,
                },
              },
              {
                id: 4,
                img: office2mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 115,
                  y: 150,
                },
              },
            ],
          },
          {
            id: 3,
            background: office3back,
            masks: [
              {
                id: 1,
                img: office3mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 540,
                  y: 40,
                },
              },
              {
                id: 2,
                img: office3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 530,
                  y: 150,
                },
              },
              {
                id: 3,
                img: office3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 615,
                  y: 160,
                },
              },
              {
                id: 4,
                img: office3mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 200,
                  y: 150,
                },
              },
            ],
          },
        ],
      },
      {
        id: 5,
        tag: "Передпокій",
        link: "peredpokiy",
        rooms: [
          {
            id: 1,
            background: peredpokiy1back,
            masks: [
              {
                id: 1,
                img: peredpokiy1mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 470,
                  y: 50,
                },
              },
              {
                id: 2,
                img: peredpokiy1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 195,
                  y: 160,
                },
              },
              {
                id: 3,
                img: peredpokiy1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 845,
                  y: 130,
                },
              },
              {
                id: 4,
                img: peredpokiy1mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 515,
                  y: 110,
                },
              },
            ],
          },
          {
            id: 2,
            background: peredpokiy2back,
            masks: [
              {
                id: 1,
                img: peredpokiy2mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 410,
                  y: 80,
                },
              },
              {
                id: 2,
                img: peredpokiy2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 800,
                  y: 150,
                },
              },
              {
                id: 3,
                img: peredpokiy2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 165,
                  y: 150,
                },
              },
            ],
          },
          {
            id: 3,
            background: peredpokiy3back,
            masks: [
              {
                id: 1,
                img: peredpokiy3mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 462,
                  y: 37,
                },
              },
              {
                id: 2,
                img: peredpokiy3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 465,
                  y: 230,
                },
              },
              {
                id: 3,
                img: peredpokiy3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 745,
                  y: 150,
                },
              },
              {
                id: 4,
                img: peredpokiy3mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 165,
                  y: 160,
                },
              },
            ],
          },
        ],
      },
      {
        id: 6,
        tag: "Санвузол",
        link: "wc",
        rooms: [
          {
            id: 1,
            background: wc1back,
            masks: [
              {
                id: 1,
                img: wc1mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 485,
                  y: 20,
                },
              },
              {
                id: 2,
                img: wc1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 438,
                  y: 150,
                },
              },
              {
                id: 3,
                img: wc1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 545,
                  y: 100,
                },
              },
              {
                id: 4,
                img: wc1mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 235,
                  y: 100,
                },
              },
            ],
          },
          {
            id: 2,
            background: wc2back,
            masks: [
              {
                id: 1,
                img: wc2mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 475,
                  y: 22,
                },
              },
              {
                id: 2,
                img: wc2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 560,
                  y: 120,
                },
              },
              {
                id: 3,
                img: wc2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 315,
                  y: 130,
                },
              },
              {
                id: 4,
                img: wc2mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 678,
                  y: 43,
                },
              },
              {
                id: 5,
                img: wc2mask5,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "D",
                },
                position: {
                  x: 165,
                  y: 160,
                },
              },
            ],
          },
          {
            id: 3,
            background: wc3back,
            masks: [
              {
                id: 1,
                img: wc3mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 615,
                  y: 130,
                },
              },
              {
                id: 2,
                img: wc3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 500,
                  y: 170,
                },
              },
              {
                id: 3,
                img: wc3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 115,
                  y: 170,
                },
              },
            ],
          },
        ],
      },
      {
        id: 7,
        tag: "Спальня",
        link: "bedroom",
        rooms: [
          {
            id: 1,
            background: bedroom1back,
            masks: [
              {
                id: 1,
                img: bedroom1mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 550,
                  y: 20,
                },
              },
              {
                id: 2,
                img: bedroom1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 390,
                  y: 100,
                },
              },
              {
                id: 3,
                img: bedroom1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 200,
                  y: 130,
                },
              },
              {
                id: 4,
                img: bedroom1mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 60,
                  y: 170,
                },
              },
            ],
          },
          {
            id: 2,
            background: bedroom2back,
            masks: [
              {
                id: 1,
                img: bedroom2mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 475,
                  y: 40,
                },
              },
              {
                id: 2,
                img: bedroom2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 506,
                  y: 110,
                },
              },
              {
                id: 3,
                img: bedroom2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 280,
                  y: 130,
                },
              },
            ],
          },
          {
            id: 3,
            background: bedroom3back,
            masks: [
              {
                id: 1,
                img: bedroom3mask1,
                tag: {
                  type: "ceil",
                  name: "Стеля",
                  subName: "",
                },
                position: {
                  x: 452,
                  y: 20,
                },
              },
              {
                id: 2,
                img: bedroom3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 305,
                  y: 130,
                },
              },
              {
                id: 3,
                img: bedroom3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 480,
                  y: 130,
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    type: "exterior",
    data: [
      {
        id: 1,
        tag: "Котедж",
        link: "cottage",
        rooms: [
          {
            id: 1,
            background: cottage1back,
            masks: [
              {
                id: 1,
                img: cottage1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 650,
                  y: 195,
                },
              },
              {
                id: 2,
                img: cottage1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 460,
                  y: 135,
                },
              },
              {
                id: 3,
                img: cottage1mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 185,
                  y: 255,
                },
              },
            ],
          },
          {
            id: 2,
            background: cottage2back,
            masks: [
              {
                id: 1,
                img: cottage2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 500,
                  y: 280,
                },
              },
              {
                id: 2,
                img: cottage2mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 580,
                  y: 230,
                },
              },
              {
                id: 3,
                img: cottage2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 275,
                  y: 120,
                },
              },
            ],
          },
          {
            id: 3,
            background: cottage3back,
            masks: [
              {
                id: 1,
                img: cottage3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 710,
                  y: 200,
                },
              },
              {
                id: 2,
                img: cottage3mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 425,
                  y: 130,
                },
              },
              {
                id: 3,
                img: cottage3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 540,
                  y: 270,
                },
              },
            ],
          },
        ],
      },
      {
        id: 2,
        tag: "Танхаус",
        link: "townhouse",
        rooms: [
          {
            id: 1,
            background: townhouse1back,
            masks: [
              {
                id: 1,
                img: townhouse1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 798,
                  y: 165,
                },
              },
              {
                id: 2,
                img: townhouse1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 400,
                  y: 240,
                },
              },
              {
                id: 3,
                img: townhouse1mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 380,
                  y: 150,
                },
              },
            ],
          },
          {
            id: 2,
            background: townhouse2back,
            masks: [
              {
                id: 1,
                img: townhouse2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 480,
                  y: 290,
                },
              },
              {
                id: 2,
                img: townhouse2mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 430,
                  y: 180,
                },
              },
              {
                id: 3,
                img: townhouse2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 615,
                  y: 70,
                },
              },
            ],
          },
          {
            id: 3,
            background: townhouse3back,
            masks: [
              {
                id: 1,
                img: townhouse3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 570,
                  y: 50,
                },
              },
              {
                id: 2,
                img: townhouse3mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 300,
                  y: 80,
                },
              },
              {
                id: 3,
                img: townhouse3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 490,
                  y: 170,
                },
              },
            ],
          },
        ],
      },
      {
        id: 3,
        tag: "Багатоповерхівка",
        link: "highrise",
        rooms: [
          {
            id: 1,
            background: highrise1back,
            masks: [
              {
                id: 1,
                img: highrise1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 520,
                  y: 110,
                },
              },
              {
                id: 2,
                img: highrise1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 480,
                  y: 290,
                },
              },
              {
                id: 3,
                img: highrise1mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 317,
                  y: 120,
                },
              },
            ],
          },
          {
            id: 2,
            background: highrise2back,
            masks: [
              {
                id: 1,
                img: highrise2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 420,
                  y: 140,
                },
              },
              {
                id: 2,
                img: highrise2mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 420,
                  y: 60,
                },
              },
              {
                id: 3,
                img: highrise2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 770,
                  y: 70,
                },
              },
            ],
          },
          {
            id: 3,
            background: highrise3back,
            masks: [
              {
                id: 1,
                img: highrise3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 320,
                  y: 100,
                },
              },
              {
                id: 2,
                img: highrise3mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 600,
                  y: 150,
                },
              },
              {
                id: 3,
                img: highrise3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 70,
                  y: 150,
                },
              },
            ],
          },
        ],
      },
      {
        id: 4,
        tag: "Адміністративні будівлі",
        link: "administrative",
        rooms: [
          {
            id: 1,
            background: administrative1back,
            masks: [
              {
                id: 1,
                img: administrative1mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 266,
                  y: 315,
                },
              },
              {
                id: 2,
                img: administrative1mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 150,
                  y: 128,
                },
              },
              {
                id: 3,
                img: administrative1mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 270,
                  y: 150,
                },
              },
            ],
          },
          {
            id: 2,
            background: administrative2back,
            masks: [
              {
                id: 1,
                img: administrative2mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 415,
                  y: 120,
                },
              },
              {
                id: 2,
                img: administrative2mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 350,
                  y: 187,
                },
              },
              {
                id: 3,
                img: administrative2mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 697,
                  y: 180,
                },
              },
            ],
          },
          {
            id: 3,
            background: administrative3back,
            masks: [
              {
                id: 1,
                img: administrative3mask2,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "A",
                },
                position: {
                  x: 120,
                  y: 220,
                },
              },
              {
                id: 2,
                img: administrative3mask1,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "B",
                },
                position: {
                  x: 400,
                  y: 333,
                },
              },
              {
                id: 3,
                img: administrative3mask3,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "C",
                },
                position: {
                  x: 555,
                  y: 270,
                },
              },
              {
                id: 4,
                img: administrative3mask4,
                tag: {
                  type: "wall",
                  name: "Стіна",
                  subName: "D",
                },
                position: {
                  x: 425,
                  y: 190,
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export const filter = [
  { id: 1, segment: "Червоні" },
  { id: 2, segment: "Помаранчеві" },
  { id: 3, segment: "Жовті" },
  { id: 4, segment: "Зелені" },
  { id: 5, segment: "Сині" },
  { id: 6, segment: "Фіолетові" },
  { id: 7, segment: "Коричневі" },
  { id: 8, segment: "Сірі" },
  { id: 9, segment: "Нейтральні" },
];
